"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var next_1 = require("@alifd/next");
var task_1 = require("@alife/task");
var Cookie = require("js-cookie");
var drive_1 = require("../drive");
var commGpy_1 = require("./commGpy");
var oldGpy_1 = require("./oldGpy");
var contextManage_1 = require("../../contextManage");
//高拍仪入口
var gpy = function (props) {
    var context = react_1.useContext(contextManage_1.DeviceTaskContext);
    var _a = react_1.useState(false), isOldGpy = _a[0], setIsOldGpy = _a[1]; //是否是非通用高拍仪
    var _b = react_1.useState(null), gpyInstance = _b[0], setGpyInstance = _b[1]; //高拍仪实例
    react_1.useEffect(function () {
        gpyPreHandler();
    }, []);
    //高拍仪加载的前置准备逻辑
    //1、判断高拍仪是否连接，没有连接的话，先加载驱动并连接
    //2、判断是通用高拍仪还是非通用高拍仪，两者 UI 不一样
    var gpyPreHandler = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            console.log("gpy pre Handler");
            getModuleData();
            return [2 /*return*/];
        });
    }); };
    var getDeviceJs = function (deviceType) { return __awaiter(_this, void 0, void 0, function () {
        var uniqueDeviceTag, gpyModule, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    uniqueDeviceTag = task_1.Util.encode({
                        hallId: Cookie.get("departmentId") || "",
                        type: "gpy",
                        deviceType: deviceType,
                    });
                    return [4 /*yield*/, drive_1.getIsvModule(uniqueDeviceTag)];
                case 1:
                    gpyModule = _a.sent();
                    console.log(gpyModule, "=======gpyModule");
                    if (!gpyModule) {
                        return [2 /*return*/];
                    }
                    if (!gpyModule.get_version) { //表示非通用高拍仪
                        console.log(gpyModule.get_version, "=====version==");
                        setIsOldGpy(true);
                    }
                    setGpyInstance(gpyModule);
                    // 初始化高拍仪实例
                    // tslint:disable-next-line: no-unused-expression
                    // props.moduleLoadSuccess && props.moduleLoadSuccess();
                    return [2 /*return*/];
                case 2:
                    e_1 = _a.sent();
                    next_1.Message.error("高拍仪连接失败");
                    throw e_1;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    //连接高拍仪
    var getModuleData = function () { return __awaiter(_this, void 0, void 0, function () {
        var deviceType, data;
        return __generator(this, function (_a) {
            try {
                deviceType = Cookie.get('GpyType') || '';
                // 唤起选择高拍仪弹窗
                if (!deviceType) {
                    if (self !== top) {
                        data = {
                            type: "deviceConnect",
                            data: "gpy",
                        };
                        // tslint:disable-next-line: no-unused-expression
                        props.fail && props.fail();
                        window.top.postMessage(data, '*');
                        context.closeDialog();
                        return [2 /*return*/];
                    }
                    else {
                        // 脚本加载失败，高拍仪未连接，调用上层的设备管理对话框
                        // tslint:disable-next-line: no-unused-expression
                        props.fail && props.fail();
                        return [2 /*return*/];
                    }
                }
                getDeviceJs(deviceType);
            }
            catch (error) {
                next_1.Message.error('请先选择具体设备！' + JSON.stringify(error || {}));
                throw error;
            }
            return [2 /*return*/];
        });
    }); };
    var renderGpy = function () {
        if (gpyInstance && isOldGpy) {
            return React.createElement(oldGpy_1.default, { gpyInstance: gpyInstance });
        }
        if (gpyInstance && !isOldGpy) {
            return React.createElement(commGpy_1.default, { gpyInstance: gpyInstance, gpyTotal: props.gpyTotal, height: props.height, width: props.width });
        }
        return React.createElement(React.Fragment, null);
    };
    return (React.createElement(React.Fragment, null, renderGpy()));
};
exports.default = gpy;
